var $ = jQuery.noConflict();

$(document).on("click", ".btn.vote", function(e){

    e.preventDefault();

    var id = $(this).attr('data-id');
    var self = $(this);

    $(this).find(".spinner-border").css("display", "inline-block");
    $(this).find(".text").css("display", "none"); 

    $.ajax({
        url: ge.ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'vote',
            //security: security,
            id: id
        }
    }).done(function(data){
        console.log("data", data);

        self.find(".spinner-border").css("display", "none");
        self.find(".text").css("display", "block");

        if(data.status == "vote-on-app"){
            $('#app-vote-modal').modal();
        }

        // // logged out
        // if(data.status == "logged-out"){
        //     $('#login-modal').modal();
        // }

        // // success
        // if(data.status == "success"){

        //     var is_page_competitor = self.closest('.page-competitor').length;

        //     //page competitor detail
        //     if(is_page_competitor){
        //         self.closest(".container-wrapper").addClass("voted");
        //         //update counter
        //         $(".detail .vote .value").html(data.vote_count);
        //     }
        //     //list item
        //     else{
        //         self.closest(".item").addClass("voted");
        //     }

        //     var is_competitors_list_item = $(".competitors-list .item-" + id).length;
        //     if(is_competitors_list_item){
        //         $(".competitors-list .item-" + id + " .vote .value").html(data.vote_count);
        //         $(".competitors-list .item-" + id).addClass('voted');
        //     }

        // }

    });

});


// WEBPACK FOOTER //
// ./assets/js/vote.js